import moment from 'moment';

import BaseService from './base.service';

export default class AuthService extends BaseService {
  async login(loginEmail, password, recaptchaToken) {
    const { accessToken, workspaceId, name, phoneNumber, role, email, foundUserInSubDomain, workspaces } = await this.post('auth/login', {
      email: loginEmail?.toLowerCase(),
      password,
      recaptchaToken,
    });

    if (accessToken) localStorage.setItem('accessToken', accessToken);
    if (workspaceId) localStorage.setItem('workspaceId', workspaceId);
    this.storeLastUpTime();
    return { email, foundUserInSubDomain, name, phoneNumber, role, workspaces };
  }

  loginToken(token) {
    localStorage.setItem('accessToken', token);
    this.storeLastUpTime();
  }

  async register(data) {
    const { dateOfBirth, email } = data;
    const utcDateOfBirth = new Date(dateOfBirth);
    await this.post('auth/register', {
      ...data,
      dateOfBirth: moment(utcDateOfBirth).utc(true).format(),
      email: email?.toLowerCase(),
    });
  }

  logout() {
    localStorage.removeItem('accessToken');
    localStorage.removeItem('lastUpTime');
  }

  async getIsMediphanyWorkspace() {
    const defaultDomain = process.env.REACT_APP_DOMAIN_POSTFIX;
    const subdomain = window.location.host === defaultDomain ? '' : window.location.host.split('.')[0];
    return this.get(`/auth/sub-domain?subdomain=${subdomain}`);
  }

  async forgotPassword(payload) {
    await this.post('auth/forgot-password', payload);
  }

  async forgotPasswordV2Captcha(payload) {
    await this.post('auth/forgot-password-v2', payload);
  }

  async validateInviteToken(token) {
    await this.get(`auth/invitation-check/${token}`);
  }

  async validateForgotToken(token) {
    await this.get(`auth/reset-token-check/${token}`);
  }

  async setForgotPassword(token, password, shouldLogin = false) {
    const { accessToken, workspaceId, name, phoneNumber, role, email, foundUserInSubDomain, workspaces } = await this.post('auth/reset-password', {
      isInvite: shouldLogin,
      password,
      token,
    });

    if (!shouldLogin) return { email, foundUserInSubDomain, name, phoneNumber, role, workspaces };

    if (accessToken) localStorage.setItem('accessToken', accessToken);
    if (workspaceId) localStorage.setItem('workspaceId', workspaceId);
    this.storeLastUpTime();
    return { email, foundUserInSubDomain, name, phoneNumber, role, workspaces };
  }
}
